jQuery($ => {
	const context = $('body');
	if ($(".anchor-nav", context).length) {
		var $anchorNav = $(".anchor-nav", context);
		var headerOffset = getHeaderOffset();

		// Placeholder, so page does not get shorter when nav is sticky
		$anchorNav.after('<div class="anchor-nav-placeholder"></div>');

		// Magellan
		var $anchorNavMenu = $anchorNav.find(".menu-links");
		$anchorNavMenu.find("a").each(function () {
			var $target = $(this.hash);
			$target.attr("data-magellan-target", this.hash.substr(1));
		});
		var anchorNavMagellan = new Foundation.Magellan($anchorNavMenu, {
			threshold: headerOffset + $anchorNav.outerHeight(),
		});

		// Override for scroll behaviour to add offset
		$anchorNavMenu.one("scrollme.zf.trigger", function () {
			$anchorNavMenu.off("click.zf.magellan");
			$anchorNavMenu.find("a").each(function () {
				new Foundation.SmoothScroll($(this), {
					animationDuration: 600,
					offset: headerOffset + $anchorNav.outerHeight() - 1,
					threshold: 0,
				});
			});
		});

		// Nav indicator
		$anchorNavMenu.on("update.zf.magellan", function () {
			var $active = $(anchorNavMagellan.$active[0]);
			var $indicator = $anchorNav.find(".nav-indicator");

			if ($active.length) {
				var offsetLeft = $active.offset().left - $anchorNav.offset().left;
				var offsetRight =
						$anchorNav.outerWidth() - (offsetLeft + $active.outerWidth());

				$indicator
				.css({
					left: offsetLeft,
					right: offsetRight,
				})
				.addClass("active");
			} else {
				$indicator.removeClass("active");
			}
		});

		// Scroll top
		$anchorNav.find(".menu-top-link").on("click", function (e) {
			e.preventDefault();

			$("html, body").animate(
					{
						scrollTop: 0,
					},
					600
			);
		});

		// Fixed nav
		$(window)
		.once("dealer:window.scroll")
		.on("scroll", function () {
			var stageHeight = 0;
			if ($(".stage-slider-fullscreen").length > 0) {
				stageHeight = $(".stage-slider-fullscreen").outerHeight();
				if ($(".slider-fullscreen.text-only").length) {
					stageHeight += $(".slider-fullscreen.text-only").outerHeight();
				}
			} else if ($(".stage-fullscreen").length > 0) {
				stageHeight = $(".stage-fullscreen").outerHeight();
			} else if ($(".stage-img-fullwidth").length > 0) {
				stageHeight = $(".stage-img-fullwidth").outerHeight();
			}

			if ($("#block-jaguar-local-tasks").length > 0) {
				stageHeight += $("#block-jaguar-local-tasks").outerHeight();
			}

			if ($(window).scrollTop() >= stageHeight) {
				var positionTop = getHeaderOffset();

				$anchorNav.css("top", positionTop);
				$anchorNav.addClass("scrolled");
			} else if ($anchorNav.hasClass("scrolled")) {
				$anchorNav.removeClass("scrolled");
				$anchorNav.css("top", "");
			}
		});

		window.addEventListener("message", function (event) {
			if (!isNaN(parseFloat(event.data))) {
				$anchorNavMenu.foundation("calcPoints");
				$anchorNavMenu.foundation("reflow");
			}
		});

		function getHeaderOffset() {
			return (
					$(".site-header").outerHeight() + $(".site-header").position().top
			);
		}
	}
})
